export const actionProcessGifXml = () => {
  return `
  ${processGif}
  ${setGlobalVariables}
  ${mainExecuteAction}
  `
}

const processGif = `
  <action name="processed_gif" type="Javascript"><![CDATA[
    (async function() {
      const currentPanoId = krHooks.getCurrentPanoramaId();
      krpano.set("currentPanoId", currentPanoId);
      krpano.call("set_current_pano_gif_hotspots()");
      if (krHooks.getGifInfos().has(currentPanoId) === false) {
        await krHooks.convertGifToSprite();
        krpano.call("set_current_pano_original_hs_properties_map()");
      }
      krpano.call("change_hs_properties()");
    })();
  ]]></action>
`

const setGlobalVariables = `
  <action name="set_current_pano_gif_hotspots" type="Javascript"><![CDATA[
    let filterHotspots = krpano.hotspot.getArray().filter(hs => hs.name.startsWith("marker_") && hs.url.includes(".gif"));
    krpano.set("currentPanoGifHotspots", filterHotspots);
  ]]></action>

  <action name="set_current_pano_original_hs_properties_map" type="Javascript"><![CDATA[
    let hotspots = krpano.get("currentPanoGifHotspots");
    let originalHotspots = krpano.get("currentPano_originalHsProperty_Map");
    const panoId = krpano.get("currentPanoId");

    if (originalHotspots === null) { originalHotspots = new Map(); }
    if (originalHotspots.has(panoId) === false) {
      const result = hotspots.reduce((acc, hs) => {
        const { name, style, url, scale, keep, renderer, onloaded, width, height } = hs;
        acc.set(name, {
          name,
          style,
          url,
          scale: Number(scale),
          keep: Boolean(keep),
          renderer,
          onloaded,
          width: Number(Number(width).toFixed(2)),
          height: Number(Number(height).toFixed(2)),
        });
        return acc;
      }, new Map());
      originalHotspots.set(panoId, result);
      krpano.set("currentPano_originalHsProperty_Map", originalHotspots);
    }
  ]]></action>
`

const mainExecuteAction = `
  <action name="change_hs_properties" type="Javascript"><![CDATA[
    const hotspots = krpano.get("currentPanoGifHotspots");
    const panoId = krpano.get("currentPanoId");
    const gifMap = krHooks.getGifInfos();
    hotspots.forEach(hs => {
      const objectId = hs.name.replace("marker_", "");
      const value = gifMap.get(panoId).get(objectId);
      if (value) {
        const { type, blob, frameLength, frameWidth, frameHeight, tagSizeRatio, ROW, duration } = value;
        const { resizeWidth, resizeHeight } = krHooks.getResizeSize({ width: frameWidth, height: frameHeight });
        const frameRate = krHooks.getFrameRate(frameLength);
        hs.style = type;
        hs.url = blob;
        hs.keep = false;
        hs.width = resizeWidth;
        hs.height = resizeHeight;
        hs.scale = tagSizeRatio;
        hs.visible = true;
        const actionName = "do_crop_animation(" + frameWidth + "," + frameHeight + "," + frameRate + "," + frameLength + ',' + ROW + ',' + duration + ");";
        hs.onloaded = actionName;
      }
    });
  ]]></action>

  <action name="revert_hs_properties" type="Javascript"><![CDATA[
    const hotspots = krpano.get("currentPanoGifHotspots");
    const panoId = krpano.get("currentPanoId");
    const hsPropertyMap = krpano.get("currentPano_originalHsProperty_Map");
    hotspots.forEach(hs => {
      const value = hsPropertyMap.get(panoId).get(hs.name);
      if (value) {
        const { style, url, keep, width, height, scale, onloaded, visible } = value;
        hs.style = style;
        hs.url = url;
        hs.keep = keep;
        hs.width = width;
        hs.height = height;
        hs.scale = scale;
        hs.onloaded = onloaded;
        hs.visible = visible;
      }
    });
  ]]></action>
`
